module.exports = __webpack_public_path__ + "img/Winterstrand.28d00409.svg";